import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SpinnerService } from 'src/app/services/loading-service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // Enable OnPush strategy
})
export class SpinnerComponent implements OnInit {
  isLoading$!: Observable<boolean>; // Use Observable instead of Subscription

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.isLoading$ = this.spinnerService.spinnerVisibility$;
  }
}
